<svg width="160" height="100" viewBox="0 0 160 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 13L50 50L13 87" stroke="black" stroke-width="5" />
    <path d="M147 13L110 50L147 87" stroke="black" stroke-width="5" />
    <path d="M100 40L80 20L60 40" stroke="black" stroke-width="5" />
</svg>

